import React, {useContext} from 'react'
import {Box} from '@material-ui/core/'
import {useTranslation} from 'react-i18next'
import useStyles from './BarcodeFieldPreview.styles'
import BarcodeWizardSheetPreview from '../BarcodeWizardPreview/BarcodeWizardSheetPreview'
import {BarcodeSheetRecordContext} from '../../context/BarcodeSheetRecord'

function BarcodeFieldPreview(props) {
  const classes = useStyles()
  const {t} = useTranslation()
  const {barcodeSheetRecord} = useContext(BarcodeSheetRecordContext)

  return (
    <div>
      <Box borderColor="grey.500" className={classes.firstPreview} id="test" clone>
        <BarcodeWizardSheetPreview
          sheetRecord={barcodeSheetRecord}
          page={props.page}
          startPosition={props.barcodeStartPosition}
          onClickButton={props.changePosition}
        />
      </Box>

      <Box marginBottom={5} marginTop={2} textAlign={'center'} fontSize={12}>
        <Box fontWeight={700} display={'inline'}>
          {t('barcode.wizard.field-preview.note')}
        </Box>{' '}
        {t('barcode.wizard.field-preview.note-details')}
      </Box>
    </div>
  )
}

export default BarcodeFieldPreview
